import { FormForType, Validators, formFor } from "fw-model";
import { AtsOrganization, AtsOrganizationPostArgs } from "models/ats-organization";

const { wrap } = Validators;

type ValidationResult = string | null;

export type FormForOrganization = FormForType<AtsOrganizationPostArgs>;

export class CreateOrganizationAction {
    public created: AtsOrganization = null;
    constructor(public form: FormForOrganization) {}
}

export class UpdateOrganizationAction {
    public updated: AtsOrganization = null;
    constructor(public form: FormForOrganization) {}
}

export class UpdatedOrganizationAction {
    constructor(public organization: AtsOrganization) {}
}

export class ReloadOrganizationOnEnsureAction {
    constructor(public organizationId: string) {}
}

export class CalculatedFieldValue {
    FieldKey: string = null;
    Value: string = null;
}

export const createOrganizationFormCreator = formFor(AtsOrganizationPostArgs, (s) => {
    s.requiredField((f) => f.Name, "Name");
    s.requiredField((f) => f.Timezone, "Timezone");
    s.requiredField((f) => f.Domain, "Domain");
    s.field((f) => f.ReferencePortalDomain, "Reference Portal Domain");
    s.requiredField((f) => f.Type, "Type");
    s.field((f) => f.SalesForceId, "SalesForceId");
    s.requiredField(
        (f) => f.SeasonName,
        "Season Name",
        wrap((s: string) => {
            if (s.length > 50) return "Season Name must be between 1 and 50 characters";
            return null;
        })
    );
    s.field((f) => f.Tags, "Tags");
    s.formArray((f) => f.PropertyValues, "PropertyValues", customPropertyFormCreator(s));
});

export const updateOrganizationFormCreator = formFor(AtsOrganizationPostArgs, (s) => {
    s.requiredField((f) => f.Id, "Id");
    s.requiredField((f) => f.Name, "Name");
    s.requiredField((f) => f.Timezone, "Timezone");
    s.requiredField((f) => f.Domain, "Domain");
    s.requiredField((f) => f.Type, "Type");
    s.field((f) => f.SalesForceId, "SalesForceId");
    s.field((f) => f.Tags, "Tags");
    s.field((f) => f.Features, "Features");
    s.formArray((f) => f.PropertyValues, "PropertyValues", customPropertyFormCreator(s));
});

export const validateKey = (input: string): ValidationResult => {
    if (!/^[a-z_$]\w*$/.test(input)) return "Invalid key format";

    return null;
};

export const customPropertyFormCreator = (properties) => {
    const data = properties.length ? properties : [];
    const fieldKeys = data.map((property) => property.FieldKey);

    const validateDuplicate = (input: string): ValidationResult => {
        if (fieldKeys.indexOf(input) !== -1) return `Duplicate key '${input}'`;

        return null;
    };

    return formFor(CalculatedFieldValue, (s) => {
        s.requiredField((f) => f.FieldKey, "Field Key", wrap(validateKey, validateDuplicate));
        s.requiredField((f) => f.Value, "Value");
    });
};
